import type { PendingPayment } from 'src/interfaces/paymentsReview'

interface PendingPaymentFilters {
  search: string
  partner: string | null
}

interface PaymentsSummary {
  count: number
  totalCents: number
  partnerCount: number
}

/** Client-side filter + newest-first sort (the endpoint ignores its filters and has no ORDER BY). */
export const filterPendingPayments = (
  rows: PendingPayment[],
  filters: PendingPaymentFilters,
): PendingPayment[] => {
  const search = filters.search.trim().toLowerCase()

  return rows
    .filter((row) => {
      if (filters.partner && row.partner !== filters.partner) {
        return false
      }

      if (search === '') {
        return true
      }

      return [row.partner, row.partnerDriverName, row.partnerDriverEmail].some((field) => {
        return (field ?? '').toLowerCase().includes(search)
      })
    })
    .sort((left, right) => {
      return right.createdAt - left.createdAt
    })
}

export const summarizePayments = (rows: PendingPayment[]): PaymentsSummary => {
  const partners = new Set(
    rows.map((row) => {
      return row.partner
    }),
  )

  const totalCents = rows.reduce((sum, row) => {
    return sum + row.amount
  }, 0)

  return { count: rows.length, totalCents, partnerCount: partners.size }
}

/** The backend builds `${first} ${last}` and can emit the literal "null" for a missing half. */
export const formatDriverName = (name: string): string => {
  const trimmed = (name ?? '').trim()

  if (trimmed === '' || trimmed.split(' ').includes('null')) {
    return '—'
  }

  return trimmed
}

export const listPartners = (rows: PendingPayment[]): string[] => {
  const partners = new Set(
    rows.map((row) => {
      return row.partner
    }),
  )

  return Array.from(partners).sort((left, right) => {
    return left.localeCompare(right)
  })
}
